import type { RouteObject } from "react-router";
import { ErrorBoundary } from "../../shared/components/ErrorBoundary";
import PaymentListPage from "./ui/pages/PaymentListPage";
import PaymentDetailPage from "./ui/pages/PaymentDetailPage";
import PaymentCreatePage from "./ui/pages/PaymentCreatePage";

/**
 * Each page is wrapped individually: payments handles money, and a crash
 * while rendering one payment must not take the rest of the app down with it.
 */
export const paymentsRoutes: RouteObject[] = [
    {
        path: "/payments",
        element: (
            <ErrorBoundary>
                <PaymentListPage />
            </ErrorBoundary>
        ),
    },
    // Declared before "/payments/:id" so "new" is not read as an payment id.
    {
        path: "/payments/new",
        element: (
            <ErrorBoundary>
                <PaymentCreatePage />
            </ErrorBoundary>
        ),
    },
    {
        path: "/payments/:id",
        element: (
            <ErrorBoundary>
                <PaymentDetailPage />
            </ErrorBoundary>
        ),
    },
];
